// extracted by mini-css-extract-plugin
module.exports = {"form":"Incident_form__IBr9u","chip":"Incident_chip__30J7P"};